<template>
  <div id="map-beige2-container" class="map">
    <!-- custom popup component -->
    <Popup />

    <!-- radio input component -->
    <InputDiplomacy />

    <!-- legends -->
    <!-- <LegendPower v-show="currentPage === 6.1" />
    <LegendPorts v-show="currentPage === 6.2" /> -->
  </div>
</template>

<script>
import * as d3 from 'd3';
import { mapGetters } from 'vuex';

import mapServices from '@/services/map';

// components
import Popup from '@/components/ui/map/Popup.vue';
import InputDiplomacy from '@/components/ui/map/InputDiplomacy.vue';
import LegendPower from '@/components/ui/map/LegendPower.vue';
import LegendPorts from '@/components/ui/map/LegendPorts.vue';

export default {
  name: 'MapBeige2',
  components: {
    Popup,
    InputDiplomacy,
    LegendPower,
    LegendPorts,
  },
  data() {
    return {
      map: null,
      defaultOptions: {
        container: 'map-beige2-container',
        style: 'mapbox://styles/kontinentalist/cjlq3un8l1lxo2rp5o8ixlqf4',
        center: [101.298529, 37.149504],
        zoom: 2.75,
      },
    };
  },
  computed: {
    ...mapGetters('view', ['currentPage', 'step', 'cameraView']),
    ...mapGetters('viewDiplomacy', ['diplomacyType', 'selectedDiplomacy']),
    ...mapGetters('mapState', ['mapOptions', 'mapLayers']),
  },
  watch: {
    currentPage(newVal, oldVal) {
      this.handleSectionPage(newVal, oldVal);
    },
    step(newVal, oldVal) {
      this.handleSectionStep(newVal, oldVal);
    },
    cameraView(newVal) {
      this.handleMapCamera(newVal);
    },
    selectedDiplomacy(newVal, oldVal) {
      this.handleDiplomacyInput(newVal, oldVal);
    },
  },
  mounted() {
    // init Mapbox
    this.map = mapServices.createMap(this.defaultOptions);
  },
  methods: {
    handleSectionPage(currentPage, previousPage) {
      switch (previousPage) {
        case 5.1:
          this.cleanMap('bilateral');
          break;

        case 5.2:
          this.cleanMap('BRICS');
          break;

        case 5.22:
          this.cleanMap('Shanghai_C');
          break;

        case 5.23:
          this.cleanMap('16_1');
          break;

        case 5.24:
          this.cleanMap('Lancang_Me');
          break;

        case 6:
          this.cleanMap('conflict');
          break;

        case 6.1:
          // Map
          this.cleanMap('power');
          break;

        case 6.2:
          this.cleanMap('ports');
          break;

        default:
          break;
      }
      switch (currentPage) {
        case 5:
          this.loadMapEvents(false, 6);
          break;

        case 5.1:
          // add geojson source - bilateral layer
          this.map.addSource('bilateral', {
            type: 'geojson',
            data: '/data/map/diplomacy/bilateral.json',
          });

          // get layer settings
          // let layers = this.mapLayers(5);

          // add layer to map
          this.map.addLayer(this.mapLayers(5)[0], 'state-label-sm');
          break;

        case 5.2:
          this.loadMapEvents(false, 6);

          // add geojson source - BRICS layer
          this.map.addSource('BRICS', {
            type: 'geojson',
            data: '/data/map/diplomacy/BRICS.json',
          });

          // get layer settings
          // let layerBRICS = this.mapLayers(5).find(layer => layer.id === 'BRICS');

          // add layer to map
          this.map.addLayer(this.mapLayers(5).find(layer => layer.id === 'BRICS'), 'state-label-sm');
          break;

        case 5.22:
          // add geojson source - Shanghai_C layer
          this.map.addSource('Shanghai_C', {
            type: 'geojson',
            data: '/data/map/diplomacy/Shanghai_C.json',
          });

          // get layer settings
          // let layerShanghaiC = this.mapLayers(5).find(layer => layer.id === 'Shanghai_C');

          // add layer to map
          this.map.addLayer(this.mapLayers(5).find(layer => layer.id === 'Shanghai_C'), 'state-label-sm');
          break;

        case 5.23:
          // add geojson source - 16_1 layer
          this.map.addSource('16_1', {
            type: 'geojson',
            data: '/data/map/diplomacy/16_1.json',
          });

          // get layer settings
          // let layer16_1 = this.mapLayers(5).find(layer => layer.id === '16_1');

          // add layer to map
          this.map.addLayer(this.mapLayers(5).find(layer => layer.id === '16_1'), 'state-label-sm');
          break;

        case 5.24:
          // add geojson source - Lancang_Me layer
          this.map.addSource('Lancang_Me', {
            type: 'geojson',
            data: '/data/map/diplomacy/Lancang_Me.json',
          });

          // get layer settings
          // let layerLancangMe = this.mapLayers(5).find(layer => layer.id === 'Lancang_Me');

          // add layer to map
          this.map.addLayer(this.mapLayers(5).find(layer => layer.id === 'Lancang_Me'), 'state-label-sm');
          break;

        case 6:
          // Map layers
          this.loadMap6Layers('conflict');
          this.loadMapEvents(true, 6);
          break;

        case 6.1:
          // Map layers
          this.loadMap6Layers('power');
          break;

        case 6.2:
          // Map layers
          this.loadMap6Layers('ports');
          break;

        default:
          break;
      }
    },
    handleSectionStep(currentStep, previousStep) {
      switch (previousStep) {
        case '5-3':
          // UI
          d3.select('.mapboxgl-custom-input').style('display', 'none');
          d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');

          // Map
          this.cleanMap(this.diplomacyType);
          this.loadMapEvents(false, 5);

          // Reset diplomacy state
          this.$store.dispatch('viewDiplomacy/updateDiplomacy', 'Memorandum of Understanding');
          this.$store.dispatch('viewDiplomacy/updateType', 'bilateral');
          break;

        case '6-0':
          // UI
          d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
          break;

        case '6-1':
          // UI
          d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
          break;

        case '6-3':
          // UI
          d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
          break;

        case '6-5':
          // UI
          d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
          break;

        default:
          break;
      }
      switch (currentStep) {
        case '5-0':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-1':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);

          // this.map.setPaintProperty('bilateral', 'fill-color', 'transparent');
          // this.map.setPaintProperty('bilateral', 'fill-outline-color', '#ff6505');
          break;

        case '5-1-2':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-2':
          // this.loadMap5Layers('multilateral');
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);

          // disable map interaction
          this.map.dragPan.disable();
          d3.select(this.map.getCanvas().parentElement).classed('mapboxgl-interactive', false);
          break;

        case '5-2-1':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-2-2':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-2-3':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-2-4':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-2-5':
          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);
          break;

        case '5-3':
          // UI
          d3.select('.mapboxgl-custom-input').style('display', 'block');

          // update camera view
          this.$store.dispatch('view/updateCameraView', currentStep);

          // Map
          this.loadMap5Layers('bilateral', 'Memorandum of Understanding');
          this.loadMapEvents(true, 5);

          // enable map interaction
          this.map.dragPan.enable();
          d3.select(this.map.getCanvas().parentElement).classed('mapboxgl-interactive', true);
          break;

        case '6-0':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.0);
          break;

        case '6-0-1':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.01);
          break;

        case '6-0-2':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.02);
          break;

        case '6-0-3':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.03);
          break;

        case '6-1':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.1);
          break;

        case '6-1-1':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.11);
          break;

        case '6-2':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.2);
          break;

        case '6-2-1':
          // Camera
          this.$store.dispatch('view/updateCameraView', 6.21);
          break;

        default:
          break;
      }
    },
    handleMapCamera(cameraView) {
      switch (cameraView) {
        case '5-0':
          this.map.flyTo({
            center: [101.298529, 37.149504],
            zoom: 2.75,
          });
          break;

        case '5-1':
          this.map.flyTo({
            center: [64.647477, 29.844548],
            zoom: 1.93,
          });
          break;

        case '5-1-2':
          this.map.flyTo({
            center: [119.06151, 7.656269],
            zoom: 3.92,
          });
          break;

        case '5-2':
          this.map.flyTo({
            center: [93.021019, 36.747879],
            zoom: 2.11,
            bearing: 0,
            pitch: 0,
          });
          break;

        case '5-2-1':
          this.map.flyTo({
            center: [91.990182, 51.434543],
            zoom: 1.69,
            bearing: -0.24,
            pitch: 0,
          });
          break;

        case '5-2-2':
          this.map.flyTo({
            center: [103.210904, 53.398729],
            zoom: 2.3,
            bearing: -0.24,
            pitch: 0,
          });
          break;

        case '5-2-3':
          this.map.flyTo({
            center: [21.507166, 48.158789],
            zoom: 4.69,
            bearing: -25.84,
            pitch: 35.5,
          });
          break;

        case '5-2-4':
          this.map.flyTo({
            center: [100.582526, 15.321053],
            zoom: 5.09,
            bearing: -27.44,
            pitch: 51.5,
          });
          break;

        case '5-2-5':
          this.map.flyTo({
            center: [26.576506, -5.535568],
            zoom: 3.75,
            bearing: -23.2,
            pitch: 49.5,
          });
          break;

        case '5-3':
          this.map.flyTo({
            center: [8.324029, 36.594184],
            zoom: 2.11,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.0:
          this.map.flyTo({
            center: [84.615918, 31.459629],
            zoom: 3.26,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.01:
          this.map.flyTo({
            center: [73.132332, 34.120242],
            zoom: 5.27,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.02:
          this.map.flyTo({
            center: [104.327191, 10.776123],
            zoom: 4.62,
            bearing: -25.6,
            pitch: 55,
          });
          break;

        case 6.03:
          this.map.flyTo({
            center: [159.370123, 6.026663],
            zoom: 7.16,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.1:
          this.map.flyTo({
            center: [65.295295, 41.410113],
            zoom: 2.17,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.11:
          this.map.flyTo({
            center: [129.775671, 35.427679],
            zoom: 5.11,
            bearing: -14.28,
            pitch: 48.5,
          });
          break;

        case 6.2:
          this.map.flyTo({
            center: [-46.91, 26.76],
            zoom: 1.75,
            bearing: 0,
            pitch: 0,
          });
          break;

        case 6.21:
          this.map.flyTo({
            center: [79.909734, 7.734014],
            zoom: 6.94,
            bearing: 0,
            pitch: 0,
          });
          break;

        default:
          break;
      }
    },
    cleanMap(layerId) {
      if (layerId === 'conflict') {
        this.map.removeLayer('conflict-areas');
        this.map.removeSource('conflict-areas');
        this.map.removeLayer('conflict-borders');
        this.map.removeSource('conflict-borders');
      } else if (layerId === 'multilateral') {
        this.map.removeLayer('16_1');
        this.map.removeSource('16_1');
        this.map.removeLayer('BRICS');
        this.map.removeSource('BRICS');
        this.map.removeLayer('Lancang_Me');
        this.map.removeSource('Lancang_Me');
        this.map.removeLayer('Shanghai_C');
        this.map.removeSource('Shanghai_C');
      } else {
        this.map.removeLayer(layerId);
        this.map.removeSource(layerId);
      }
    },
    loadMap5Layers(layerId, filter = false) {
      if (layerId === 'bilateral') {
        // add geojson source
        this.map.addSource('bilateral', {
          type: 'geojson',
          data: '/data/map/diplomacy/bilateral.json',
        });

        // get layer settings
        let layers = this.mapLayers(5);

        // add layer to map
        this.map.addLayer(layers[0], 'state-label-sm');
      } else if (layerId === 'multilateral') {
        // add geojson sources
        this.map.addSource('16_1', {
          type: 'geojson',
          data: '/data/map/diplomacy/16_1.json',
        });
        this.map.addSource('BRICS', {
          type: 'geojson',
          data: '/data/map/diplomacy/BRICS.json',
        });
        this.map.addSource('Lancang_Me', {
          type: 'geojson',
          data: '/data/map/diplomacy/Lancang_Me.json',
        });
        this.map.addSource('Shanghai_C', {
          type: 'geojson',
          data: '/data/map/diplomacy/Shanghai_C.json',
        });

        let layers = this.mapLayers(5).filter(layer => layer.id != 'bilateral' && layer.id != 'multilateral');

        // add layers to map
        layers.forEach(layerOption => {
          this.map.addLayer(layerOption, 'state-label-sm');
        });
      }

      // filter map layer
      if (filter) {
        if (layerId === 'bilateral') {
          this.map.setFilter('bilateral', ['==', ['string', ['get', 'Type_1']], filter]);
        } else {
          this.map.setLayoutProperty('16_1', 'visibility', 'none');
          this.map.setLayoutProperty('BRICS', 'visibility', 'none');
          this.map.setLayoutProperty('Lancang_Me', 'visibility', 'none');
          this.map.setLayoutProperty('Shanghai_C', 'visibility', 'none');

          this.map.setLayoutProperty(filter, 'visibility', 'visible');
          // load the filtered organisation
          // this.map.setFilter('multilateral', [
          //   'all',
          //   ['match', ['get', filter], ['Member State', 'Dialogue Partner', 'Observer State'], true, false],
          // ]);
        }
      }
    },
    loadMap6Layers(layerId) {
      if (layerId === 'conflict') {
        // add geojson source
        this.map.addSource('conflict-areas', {
          type: 'geojson',
          data: '/data/map/issues/conflict-areas.json',
        });
        this.map.addSource('conflict-borders', {
          type: 'geojson',
          data: '/data/map/issues/conflict-borders.json',
        });

        // get layer settings
        let layerConflict = this.mapLayers(6);

        this.map.addLayer(layerConflict[0], 'state-label-sm'); // conflict-areas
        this.map.addLayer(layerConflict[1], 'state-label-sm'); // conflict-borders
      } else if (layerId === 'power') {
        // add geojson source
        this.map.addSource('power', {
          type: 'geojson',
          data: '/data/map/issues/power.json',
        });

        // get layer settings
        let layerPower = this.mapLayers(6.1);

        this.map.addLayer(layerPower[0], 'state-label-sm');
      } else if (layerId === 'ports') {
        // add geojson source
        this.map.addSource('ports', {
          type: 'geojson',
          data: '/data/map/issues/ports.json',
        });

        // get layer settings
        let layerPorts = this.mapLayers(6.2);

        this.map.addLayer(layerPorts[0], 'state-label-sm');
      }
    },
    loadMapEvents(load = true, page) {
      if (load) {
        if (page === 5) {
          // add click and hover events to bilateral layers
          this.map.on('mousemove', 'bilateral', this.handleMapPopup);
          this.map.on('mouseleave', 'bilateral', this.handleLayerExit);

          // add click and hover events to multilateral layers
          this.map.on('mousemove', '16_1', this.handleMapPopup);
          this.map.on('mouseleave', '16_1', this.handleLayerExit);

          this.map.on('mousemove', 'BRICS', this.handleMapPopup);
          this.map.on('mouseleave', 'BRICS', this.handleLayerExit);

          this.map.on('mousemove', 'Lancang_Me', this.handleMapPopup);
          this.map.on('mouseleave', 'Lancang_Me', this.handleLayerExit);

          this.map.on('mousemove', 'Shanghai_C', this.handleMapPopup);
          this.map.on('mouseleave', 'Shanghai_C', this.handleLayerExit);
        } else if (page === 6) {
          // add click and hover events to conflict areas layers
          this.map.on('mousemove', 'conflict-areas', this.handleMapPopup);
          this.map.on('mouseleave', 'conflict-areas', this.handleLayerExit);

          // add click and hover events to conflict borders layers
          this.map.on('mousemove', 'conflict-borders', this.handleMapPopup);
          this.map.on('mouseleave', 'conflict-borders', this.handleLayerExit);

          // add click and hover events to ports layers
          this.map.on('mousemove', 'ports', this.handleMapPopup);
          this.map.on('mouseleave', 'ports', this.handleLayerExit);
        }
      } else {
        if (page === 5) {
          // remove click and hover events to bilateral layers
          this.map.off('mousemove', 'bilateral', this.handleMapPopup);
          this.map.off('mouseleave', 'bilateral', this.handleLayerExit);

          // remove click and hover events to multilateral layers
          this.map.off('mousemove', '16_1', this.handleMapPopup);
          this.map.off('mouseleave', '16_1', this.handleLayerExit);

          this.map.off('mousemove', 'BRICS', this.handleMapPopup);
          this.map.off('mouseleave', 'BRICS', this.handleLayerExit);

          this.map.off('mousemove', 'Lancang_Me', this.handleMapPopup);
          this.map.off('mouseleave', 'Lancang_Me', this.handleLayerExit);

          this.map.off('mousemove', 'Shanghai_C', this.handleMapPopup);
          this.map.off('mouseleave', 'Shanghai_C', this.handleLayerExit);
        } else if (page === 6) {
          // remove click and hover events to conflict areas layers
          this.map.off('mousemove', 'conflict-areas', this.handleMapPopup);
          this.map.off('mouseleave', 'conflict-areas', this.handleLayerExit);

          // remove click and hover events to conflict borders layers
          this.map.off('mousemove', 'conflict-borders', this.handleMapPopup);
          this.map.off('mouseleave', 'conflict-borders', this.handleLayerExit);

          // remove click and hover events to ports layers
          this.map.off('mousemove', 'ports', this.handleMapPopup);
          this.map.off('mouseleave', 'ports', this.handleLayerExit);
        }
      }
    },
    handleMapPopup(e) {
      this.handleLayerEnter();

      // select popup element
      const popupEl = d3.select('#map-beige2-container .mapboxgl-custom-popup');

      let title = '';
      let category = '';
      let description = '';
      let description2 = '';

      let organName = '';

      // popup content
      switch (e.features[0].layer.id) {
        case 'bilateral':
          title = `${e.features[0].properties.Country} - China`;
          category = e.features[0].properties.Type_1;
          description = e.features[0].properties.Description;
          break;

        case 'multilateral':
          title = e.features[0].properties.Country;
          // organisation name
          organName = this.transformFieldName(this.selectedDiplomacy);
          category = `${organName} - ${e.features[0].properties[this.selectedDiplomacy]}`;
          description = '';
          break;

        case '16_1':
          title = e.features[0].properties.Country;
          category = e.features[0].properties[this.selectedDiplomacy];
          description = '';
          break;

        case 'BRICS':
          title = e.features[0].properties.Country;
          category = e.features[0].properties[this.selectedDiplomacy];
          description = '';
          break;

        case 'Lancang_Me':
          title = e.features[0].properties.Country;
          category = e.features[0].properties[this.selectedDiplomacy];
          description = '';
          break;

        case 'Shanghai_C':
          title = e.features[0].properties.Country;
          category = e.features[0].properties[this.selectedDiplomacy];
          description = '';
          break;

        case 'conflict-areas':
          title = e.features[0].properties.NAME_SORT;
          category = '';
          description = e.features[0].properties.descrip;
          break;

        case 'conflict-borders':
          title = e.features[0].properties.brk_name_l;
          category = e.features[0].properties.name;
          description = e.features[0].properties.descrip;
          break;

        case 'ports':
          title = e.features[0].properties.Name;
          category = e.features[0].properties.Subcategory;
          description =
            e.features[0].properties.CostUSbillions === 'null'
              ? 'Cost: Unavailable'
              : `Cost: $US ${e.features[0].properties.CostUSbillions}B`;
          description2 = `Status: ${e.features[0].properties.Status}`;
          break;

        default:
          break;
      }

      // update popup el
      popupEl.style('display', 'block').style('transform', `translate(${e.point.x}px, ${e.point.y}px)`);

      // update popup content
      this.$store.dispatch('popup/updateTitle', title);
      this.$store.dispatch('popup/updateCategory', category);
      this.$store.dispatch('popup/updateDescription', description);
      this.$store.dispatch('popup/updateDescription2', description2);
    },
    handleLayerEnter() {
      this.map.getCanvas().style.cursor = 'pointer';
    },
    handleLayerExit() {
      this.map.getCanvas().style.cursor = '';
      d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
    },
    handleDiplomacyInput(currentValue, previousValue) {
      if (this.step === '5-3') {
        // check previous layer type
        let multilateral = ['16_1', 'BRICS', 'Lancang_Me', 'Shanghai_C'];
        const previousType = multilateral.includes(previousValue) ? 'multilateral' : 'bilateral';

        // clean map
        d3.select('#map-beige2-container .mapboxgl-custom-popup').style('display', 'none');
        this.cleanMap(previousType);

        // filter map
        this.loadMap5Layers(this.diplomacyType, currentValue);
      }
    },
    transformFieldName(input) {
      let output = '';

      switch (input) {
        case 'Lancang_Me':
          output = 'Lancang-Mekong Cooperation';
          break;

        case 'Shanghai_C':
          output = 'Shanghai Cooperation Organisation';
          break;

        default:
          output = input;
          break;
      }

      return output;
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
